/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinkconnecting2Inputs */

const en_profilelinkconnecting2 = /** @type {(inputs: Profilelinkconnecting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting …`)
};

const de_profilelinkconnecting2 = /** @type {(inputs: Profilelinkconnecting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird verbunden …`)
};

/**
* | output |
* | --- |
* | "Connecting …" |
*
* @param {Profilelinkconnecting2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkconnecting2 = /** @type {((inputs?: Profilelinkconnecting2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkconnecting2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkconnecting2(inputs)
	return de_profilelinkconnecting2(inputs)
});
export { profilelinkconnecting2 as "profileLinkConnecting" }